<template>
	<div class="module_container full" style="position: relative;">
		<el-container class="full" style="position: relative;">
			<el-container class="full" style="position: relative;">
				<el-main class="main flex">
					<div style="position: relative;width: 100%;height: 70%;box-sizing: border-box;padding-bottom: 10px;">
						<vxe-grid v-if="list_gridOptions" ref="preoutorderTable" v-bind="list_gridOptions"
							@toolbar-button-click="list_toolbarButtonClickEvent" @cell-click="cellClick"></vxe-grid>
					</div>
					<div style="position: relative;width: 100%;height:30%;" >
						<footer-index :componentStore="componentStore" :currentRow="this.currentRow" ref="preoutorderFooter" />
					</div>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>
<style scoped>
	.module_container {
		box-sizing: border-box;
		padding-bottom: 10px;
	}
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	
	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import footerIndex from './footer/index.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				componentStore:{
					customreload:this.customreload,
					getcontent:this.getcontent
				},
				currentRow:null,
				currentdetail: [],
				list_formConfig: [{
					field: 'storage_uid',
					title: '仓库',
					itemRender: {
						name: '$select',
						props: {
							emptyoption: false,
							selectoptions: [{
									value: "6A62605D9BB83561AC93DCEE70535ED1",
									label: '全国仓'
								},
								{
									value: "51993633962185",
									label: '温州代发杂仓'
								},
								{
									value: "DBE2DF29216E36DFAC59F0E66D60EEBB",
									label: '佛山代发杂仓(空单用)'
								},
								{
									value: "B63418CE9F1036DDAFB958924E3B78EB",
									label: '永年代发杂仓'
								}
							]
						}
					}
				},{
					field: 'tp_tid',
					title: '系统单号',
					itemRender: {
						name: '$input'
					}
				}],
				sourcedata: [],
				tasklist: []
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			getcontent(row,detail){
				let content = []
				if(row.storage_uid == '51993633962185'){
					content.push('寄件人：蓝叶敏 13659497905')
					content.push('收件人：名字 电话 地址')
				}
				detail.forEach((item)=>{
					content.push(item.goods_name + ' '+ item.specValue + ' ' + '【'+item.tp_item_size + item.unit + '】')
				})
				content.push('代发一下，不放单据')
				return content.join('\n')
			},
			flashtask(){
				
				let tabledata = this.$refs.preoutorderTable.getTableData().fullData
				this.gettradetask(tabledata)
				
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.treeConfig = null
				gridOptions.toolbarConfig.buttons = [{
					name: '刷新任务状态',
					status: 'success',
					code: 'flashtask'
				}]
				gridOptions.tooltipConfig =  {
					showAll: true,
					enterable: true,
					contentMethod:({row,column})=>{
						if(row && column.field){
							if(column.field == 'task_process' && row.splitdetail){
								console.log(row.splitdetail)
								let data = []
								row.splitdetail.forEach((ditem)=>{
									let order = ditem.order
									let arr = []
									let warehouse = ''
									order.forEach((item)=>{
										warehouse = item.storage_name
										arr.push(item.spec_code + '【'+ item.tp_item_size + '】')
									})
									data.push(arr.join(',') + '——>' + warehouse)
								})
								
								return data.join('\n')
							}else{
								return row[column.field]
							}						
						}else{
							return ''
						}
					}
				},
				gridOptions.editConfig = {
					trigger:'click',
					mode:'cell'
				}
				gridOptions.columns = [{
						width: 50,
						align: 'center',
						type: 'seq',
						title: '#',
					}, {
						field: 'salercpt_no',
						title: '系统单号',
						filters:[{data:''}],
						filterRender:{
							name:'$input'
						}
					},
					{
						field: 'tp_tid',
						title: '线上单号',
						filters:[{data:''}],
						filterRender:{
							name:'$input'
						}
					},
					{
						field: 'storage_name',
						title: '仓库名称',
						filters:[{data:''}],
						filterRender:{
							name:'$input'
						}
					},
					{
						field: 'tp_payment',
						title: '应收款',
					},
					
					{
						field: 'tp_pay_time',
						title: '付款时间',
					},
					
					// {
					// 	field: 'tp_memo',
					// 	title: '备注',
					// },
					{
						field: 'tp_pay_time',
						title: '付款时间',
						sortable:true,
						formatter: ({
							cellValue
						}) => {
							return cellValue.replace('T', ' ').replace('Z', ' ')
						}
					},
					{
						field: 'remark',
						title: '备注'
					},
					{
						field: 'task_count',
						title: '信息发送状态'
					},
					{
						field: 'custommark',
						title: '自定义备注',
						align: 'center',
						fixed:"right",
						editRender: {
							name:'$input',
							enabled:true,
							props:{
								placeholder:'自定义备注',
							},
							events:{
								blur:({row})=>{
									this.custommarkChange(row)
								}
							}
						}
					},
					// {
					// 	field: '',
					// 	title: '操作',
					// 	width: 65,
					// 	fixed: "right",
					// 	align: 'center',
					// 	slots: {
					// 		default: ({
					// 			row
					// 		}) => {
					// 			return [ <el-button size = "mini" type = "text" onClick = {() => {this.detail(row)}}> 发送 </el-button>,										
					// 			]
					// 		}
					// 	}
					// },
				]
				gridOptions.formConfig.span = 4
			},
			custommarkChange(row){
				this.$api.preoutorder.updatefromlist(0,{
						custommark:row.custommark,
						salercpt_uid:row.salercpt_uid,
						salercpt_no:row.salercpt_no,
					}).then((res)=>{
						if(res){
							this.$message.success('操作成功')
						}				
				})
			},
			list(page, updateForm) {
				return new Promise((resolve) => {
					// let codes = [
					// 	'XD241121010386',
					// ]
					this.$api.agencysendwarehouse.wlnlistTrades(updateForm).then((res) => {
						resolve({
							list: res
						})
						// this.sourcedata = JSON.parse(JSON.stringify(res))
						// this.gettradetask(res).then(() => {
						// 	resolve({
						// 		list: res
						// 	})
						// })
					}, () => {
						resolve({
							list: []
						})
					})
				})
			},
			gettradetask(tabledata) {
				let loadinghandle = this.$loading()
				let codes = tabledata.map((item) => {
					return item.salercpt_no
				})
				return new Promise((reslove) => {
					this.$api.preoutorder.gettradetask({
						codes: codes
					}).then((res) => {
						tabledata.forEach((item) => {
							item.task_count = 0
							item.task_process = 0
							let task = res.find((_item) => {
								return _item.salercpt_no == item.salercpt_no
							})
							if (task) {
								item.task_count = task.count
								item.task_process = task.process,
								item.splitdetail = task.detail
							}
						})
						reslove()
						this.$loadingclose(loadinghandle)
					}, () => {
						reslove()
						this.$loadingclose(loadinghandle)
					})
				})
			},
			detailIndexHide() {
				this.flashtask()
			},
			detail(row) {
				let loadinghandle = this.$loading()
				this.$api.preoutorder.wlngetOrders({
					tradeUid: row.salercpt_uid,
					storageUid: row.storage_uid,
					shopUid: row.sys_shop,
					ordercode: row.salercpt_no,
				}).then((res) => {

					res.forEach((item) => {
						item.tp_tid = row.tp_tid
						item.salercpt_no = row.salercpt_no
						item.storage_name = row.storage_name
						item.storage_uid = row.storage_uid
					})
					this.currentdetail = res
					this.$loadingclose(loadinghandle)
					this.$refs.detailIndex.modal_show()
					//console.log(res)
				}, () => {
					this.$loadingclose(loadinghandle)
				})
			},
			cellClick(e) {
				if (e.column.field) {
					this.currentRow = e.row
					console.log(this.currentRow)
				}
				
			},
			submit() {

				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			footerIndex
		}
	}
</script>